import { DownloadK8sAgentWebComponent } from './component/DownloadK8sAgentWebComponent';
import { WEB_COMPONENT_DOWNLOAD_K8S_AGENT } from '../../webcomponents.constants';

export { DownloadK8sAgentWebComponent };

window.customElements.define(WEB_COMPONENT_DOWNLOAD_K8S_AGENT, DownloadK8sAgentWebComponent);
